import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { DataQualityApi } from "../../../services/DataQualityService";
import { AWS_CONFIG_TYPE } from '../../../BaseUrl';
import LoadingIcon from '../../../reusable-component/LoadingIcon';
import { useAxios } from '../../../contexts/AxiosProvider';
import DataProfilingHtml from './DataProfilingHtml';
import DataValidationHtml from './DataValidationHtml';
import { getEnvironmentConfig } from '../../../constants/CloudConstant';

const RenderHtml = ({ htmlData, nodeId, handleCloseModal, workflow }) => {
  const [html, setHtml] = useState();
  const [nodeName, setNodeName] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const axios = useAxios()

  const [loading, setloading] = useState(false)

  const nodeTypeHtml = {
    profiling: 'profiling',
    validation: 'validation',
    sample_view: 'metrics',
    training: 'metrics',
  };

  const fetchHtml = async () => {
    let node;

    try {
      const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes') || '[]');
      getAllNodes.map((el) => {
        if (el.step_name === 'DataValidation' && el.nodeId === nodeId) {
          node = el;
          setNodeName(node.formField.alias);
        }
        if (el.step_name === 'Training' && el.nodeId === nodeId) {
          node = el;
          setNodeName(node.formField.alias);
        }
      });

      console.log(node)
      const nodeTypePath = {
        profiling: `${node.formField.validation.profilingPath}`,
        validation: `${node.formField.validation.path}`,
        sample_view: `${node.formField.validation.path}/metrics`,
        training: `${node.formField.validation.path}/metrics`,
      };

      const path = nodeTypePath[htmlData];

      const originalText = AWS_CONFIG_TYPE ? path.replace('dep-qa/', '') : path.replace('dep-develop/', '');
      let pathType;
      console.log(workflow)

      if (htmlData === 'validation') {
        pathType = `${getEnvironmentConfig().BUCKET_PATH}/${workflow.engagement.clientEntity.clientName}/${workflow.engagement.engagementName}/${workflow.workflow_name}/Data_Processor/Output/Data_Profiling/${node.formField.validation.dataFrame}/validation/validation.json`;
      } else if (htmlData === 'profiling') {
        pathType = `${getEnvironmentConfig().BUCKET_PATH}/${workflow.engagement.clientEntity.clientName}/${workflow.engagement.engagementName}/${workflow.workflow_name}/Data_Processor/Output/Data_Profiling/${node.formField.validation.dataFrame}/profiling/profiling.json`;
      } else {
        pathType = `${getEnvironmentConfig().BUCKET_PATH}/${originalText}/${nodeTypeHtml[htmlData]}.html`;
      }

      let response;
      setloading(true)
      if (htmlData === 'validation' || htmlData === 'profiling') {
        response = await DataQualityApi.fetchHtmlJsonApi(axios, pathType, workflow.workflow_id);
      } else {
        response = await DataQualityApi.fetchHtmlApi(axios, pathType, workflow.workflow_id);
      }

      if (response.status === 200) {
        setHtml(response.data);
      }
    } catch (error) {
      handleCloseModal();
      console.log(error);
      enqueueSnackbar(`${htmlData} Not Done`, {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });

    } finally {
      setloading(false)
    }
  };

  useEffect(() => {
    fetchHtml();
  }, []);

  return (
    <div>
      {htmlData !== 'profiling' && htmlData !== 'validation' && <div dangerouslySetInnerHTML={{ __html: html }} />}
      {!loading && html && htmlData === 'profiling' && (
        <DataProfilingHtml nodeName={nodeName} profilingJson={html} handleCloseModal={handleCloseModal} workflow={workflow} />
      )}
      {!loading && html && htmlData === 'validation' && (
        <DataValidationHtml validationJson={html} nodeName={nodeName} handleCloseModal={handleCloseModal} workflow={workflow} />
      )}
      {
        loading && <LoadingIcon />
      }

    </div>
  );
};

export default RenderHtml;
